export const unsavedChangesModalMixins = {
    methods: {
        async showUnsavedChangesModal() {
            return await this.$swal({
                imageHeight: "30px",
                title: "You have unsaved changes!",
                text: "Are you sure you want to leave this page?",
                imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
                confirmButtonColor: "#4B8BFF",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                reverseButtons: true,
            });
        },
    },
};
